export default {
  routerList: [
    // 业务订单————运单管理
    {
      path: "/WaybillManage/NewPickupInstructionList",
      name: "NewPickupInstructionList",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/NewPickupInstruction/List",
        ], (comp) =>
          resolve({ ...comp.default, name: "NewPickupInstructionList" })),
      meta: {
        title: "订单列表",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/NewPickupInstructionAddEdit",
      name: "NewPickupInstructionAdd",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/NewPickupInstruction/AddEdit",
        ], (comp) =>
          resolve({ ...comp.default, name: "NewPickupInstructionAdd" })),
      meta: {
        title: "新建订单",
        keepAlive: true,
      },
      props ({ query: { commandId, isSee } }) {
        return { commandId, isSee };
      },
    },
    {
      path: "/WaybillManage/NewPickupInstructionEdit",
      name: "NewPickupInstructionEdit",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/NewPickupInstruction/AddEdit",
        ], (comp) =>
          resolve({ ...comp.default, name: "NewPickupInstructionEdit" })),
      meta: {
        title: "修改订单",
        keepAlive: true,
      },
      props ({ query: { commandId, isSee } }) {
        return { commandId, isSee };
      },
    },
    {
      path: "/WaybillManage/NewPickupInstructionDetail",
      name: "NewPickupInstructionDetail",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/NewPickupInstruction/AddEdit",
        ], (comp) =>
          resolve({ ...comp.default, name: "NewPickupInstructionDetail" })),
      meta: {
        title: "查看订单",
        keepAlive: true,
      },
      props ({ query: { commandId, isSee } }) {
        return { commandId, isSee };
      },
    },
    //待外发录入列表
    {
      path: "/OutgoingManage/PendingOutboundEntry/List",
      name: "PendingOutboundEntryList",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/OutgoingManage/PendingOutboundEntry/List",
        ], (comp) =>
          resolve({ ...comp.default, name: "PendingOutboundEntryList" })),
      meta: {
        title: "待外发录入列表",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/PendingOutboundEntry/SettlementEntry",
      name: "PendingOutboundEntrySettlementEntry",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/OutgoingManage/PendingOutboundEntry/SettlementEntry",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "PendingOutboundEntrySettlementEntry",
          })),
      meta: {
        title: "外发录入",
        keepAlive: true,
      },
      props ({ query: { k,v,outgoingId } }) {
        return { k,v ,outgoingId};
      },
    },
    {
      path: "/OutgoingManage/PendingOutboundEntry/addOutgoing",
      name: "PendingOutboundEntrySettlementEntry",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/OutgoingManage/PendingOutboundEntry/SettlementEntry",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "PendingOutboundEntrySettlementEntry",
          })),
      meta: {
        title: "新建外发",
        keepAlive: true,
      },
      props ({ query: { t } }) {
        return {t};
      },
    },
    {
      path: "/OutgoingManage/OutgoingTracking",
      name: "OutgoingTracking",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/OutgoingManage/OutgoingTracking"], (
          comp
        ) => resolve({ ...comp.default, name: "OutgoingTracking" })),
      meta: {
        title: "外发跟踪",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/UnqualifiedList",
      name: "UnqualifiedList",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/UnqualifiedList/List",
        ], (comp) => resolve({ ...comp.default, name: "UnqualifiedList" })),
      meta: {
        title: "不合格服务列表",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/UnqualifiedList/NewBuilt",
      name: "UnqualifiedListNewBuilt",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/UnqualifiedList/NewBuilt",
        ], (comp) =>
          resolve({ ...comp.default, name: "UnqualifiedListNewBuilt" })),
      meta: {
        title: "不合格服务",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/AbnormalSummaryTable",
      name: "AbnormalSummaryTable",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/AbnormalSummaryTable",
        ], (comp) =>
          resolve({ ...comp.default, name: "AbnormalSummaryTable" })),
      meta: {
        title: "异常总表",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/AbnormalTableCustomers",
      name: "AbnormalTableCustomers",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/AbnormalTableCustomers",
        ], (comp) =>
          resolve({ ...comp.default, name: "AbnormalTableCustomers" })),
      meta: {
        title: "异常表-客户",
        keepAlive: true,
      },
    },
    {
      path: "/DataImport/WaybillImport",
      name: "WaybillImport",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/DataImport/WaybillImport"], (comp) =>
          resolve({ ...comp.default, name: "WaybillImport" })),
      meta: {
        title: "运单导入-客户",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/PickupScheduling",
      name: "PickupScheduling",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupScheduling/PickupScheduling"], (
          comp
        ) => resolve({ ...comp.default, name: "PickupScheduling" })),
      meta: {
        title: "提货调度",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/shangmentihuo",
      name: "PickupDispatchCarShangMenTiHuo",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/index"], (comp) =>
          resolve({ ...comp.default, name: "PickupDispatchCarShangMenTiHuo" })),
      meta: {
        title: "提货派车",
        keepAlive: true,
      },
      props ({ }) {
        return { dispatchType: "shang_men_ti_huo" };
      },
    },
    {
      path: "/DispatchCar/ganxian",
      name: "PickupDispatchCarGanXian",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/index"], (comp) =>
          resolve({ ...comp.default, name: "PickupDispatchCarGanXian" })),
      meta: {
        title: "干线派车",
        keepAlive: true,
      },
      props ({ }) {
        return { dispatchType: "gan_xian_pei_zai" };
      },
    },
    {
      path: "/DispatchCar/songhuoshangmen",
      name: "PickupDispatchCarSongHuoShangMen",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/index"], (comp) =>
          resolve({
            ...comp.default,
            name: "PickupDispatchCarSongHuoShangMen",
          })),
      meta: {
        title: "送货上门",
        keepAlive: true,
      },
      props ({ }) {
        return { dispatchType: "song_huo_shang_men" };
      },
    },
    {
      path: "/DispatchCar/songchuwaifa",
      name: "PickupDispatchCarSongChuWaiFa",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/index"], (comp) =>
          resolve({ ...comp.default, name: "PickupDispatchCarSongChuWaiFa" })),
      meta: {
        title: "送出外发",
        keepAlive: true,
      },
      props ({ }) {
        return { dispatchType: "song_chu_wai_fa" };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/add/shangmentihuo",
      name: "AddShangeMenTiHuo",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "AddShangeMenTiHuo" })),
      meta: {
        title: "新建派车-上门提货",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type: "shang_men_ti_huo", op: 'add' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/add/ganxian",
      name: "AddGanXian",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "AddGanXian" })),
      meta: {
        title: "新建派车-干线派车",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type: "gan_xian_pei_zai", op: 'add' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/add/songhuoshangmen",
      name: "AddSongHuoShangMen",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "AddSongHuoShangMen" })),
      meta: {
        title: "新建派车-送货上门",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type: "song_huo_shang_men", op: 'add' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/add/songchuwaifa",
      name: "AddSongChuWaiFa",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "AddSongChuWaiFa" })),
      meta: {
        title: "新建派车-送出外发",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type: "song_chu_wai_fa", op: 'add' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/edit/shangmentihuo",
      name: "EditShangeMenTiHuo",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "EditShangeMenTiHuo" })),
      meta: {
        title: "修改派车-上门提货",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type: "shang_men_ti_huo", op: 'edit' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/edit/ganxian",
      name: "EditGanXian",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "EditGanXian" })),
      meta: {
        title: "修改派车-干线派车",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type: "gan_xian_pei_zai", op: 'edit' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/edit/songhuoshangmen",
      name: "EditSongHuoShangMen",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "EditSongHuoShangMen" })),
      meta: {
        title: "修改派车-送货上门",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type: "song_huo_shang_men", op: 'edit' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/edit/songchuwaifa",
      name: "EditSongChuWaiFa",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "EditSongChuWaiFa" })),
      meta: {
        title: "修改派车-送出外发",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee: 0, type: "song_chu_wai_fa", op: 'edit' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/add/ViewDispatchCar",
      name: "ViewDispatchCar",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "ViewDispatchCar" })),
      meta: {
        title: "查看派车",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type, op };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/add/intoStoreageDispatchCar",
      name: "intoStoreageDispatchCar",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "intoStoreageDispatchCar" })),
      meta: {
        title: "卸货入库-提货",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type, op: 'intoStoreage' };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/add/FeeCheckInDispatchCar",
      name: "FeeCheckInDispatchCar",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/add/AddDispatchCar"], (
          comp
        ) => resolve({ ...comp.default, name: "FeeCheckInDispatchCar" })),
      meta: {
        title: "费用录入",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type, op };
      },
    },
    {
      path: "/DispatchCar/PickupDispatchCar/allocation/fee",
      name: "AllocationFee",
      component: (resolve) =>
        require(["@/pages/DispatchCar/PickupDispatchCar/allocation/fee"], (
          comp
        ) => resolve({ ...comp.default, name: "AllocationFee" })),
      meta: {
        title: "车费摊分",
        keepAlive: true,
      },
      props ({ query: { dispatchId, isSee, type, op } }) {
        return { dispatchId, isSee, type, op };
      },
    },
    {
      path: "/DispatchCar/OnwayTrace/list",
      name: "OnwayTraceList",
      component: (resolve) =>
        require(["@/pages/DispatchCar/OnwayTrace/list"], (
          comp
        ) => resolve({ ...comp.default, name: "OnwayTraceList" })),
      meta: {
        title: "在途跟踪",
        keepAlive: true,
      }
    },
    {
      path: "/DispatchCar/FinishCar/finishCar",
      name: "FinishCar",
      component: (resolve) =>
        require(["@/pages/DispatchCar/FinishCar/index"], (comp) =>
          resolve({ ...comp.default, name: "FinishCar" })),
      meta: {
        title: "到车管理",
        keepAlive: true,
      },
      props ({ }) {
        return { dispatchType: "gan_xian_pei_zai" };
      },
    },
    {
      path: "/DispatchCar/CarTiming",
      name: "CarTiming",
      component: (resolve) =>
        require(["@/pages/DispatchCar/CarTiming"], (comp) =>
          resolve({ ...comp.default, name: "CarTiming" })),
      meta: {
        title: "车次详情",
        keepAlive: true,
      },
      props ({query:{dispatchNumber} }) {
        return { dispatchType: "shang_men_ti_huo" ,dispatchNumberX:dispatchNumber};
      },
    },
    {
      path: "/DispatchCar/WaybillLoading",
      name: "WaybillLoading",
      component: (resolve) =>
        require(["@/pages/DispatchCar/WaybillLoading/WaybillLoading"], (comp) =>
          resolve({ ...comp.default, name: "WaybillLoading" })),
      meta: {
        title: "运单配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/ReceivingDispatcher",
      name: "ReceivingDispatcher",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/ReceivingDispatcher/ReceivingDispatcher",
        ], (comp) => resolve({ ...comp.default, name: "ReceivingDispatcher" })),
      meta: {
        title: "接收调度员",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/DeliveryScheduling",
      name: "DeliveryScheduling",
      component: (resolve) =>
        require(["@/pages/DispatchCar/DeliveryScheduling/DeliveryScheduling"], (
          comp
        ) => resolve({ ...comp.default, name: "DeliveryScheduling" })),
      meta: {
        title: "送货调度",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/DeliveryScheduling/MultipleTicketDelivery",
      name: "MultipleTicketDelivery",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/DeliveryScheduling/MultipleTicketDelivery",
        ], (comp) =>
          resolve({ ...comp.default, name: "MultipleTicketDelivery" })),
      meta: {
        title: "多票派车",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/OutgoingDispatch",
      name: "OutgoingDispatch",
      component: (resolve) =>
        require(["@/pages/DispatchCar/OutgoingDispatch/OutgoingDispatch"], (
          comp
        ) => resolve({ ...comp.default, name: "OutgoingDispatch" })),
      meta: {
        title: "外发调度",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/DispatchCar",
      name: "DispatchCar",
      component: (resolve) =>
        require(["@/pages/DispatchCar/OutgoingDispatch/DispatchCar"], (comp) =>
          resolve({ ...comp.default, name: "DispatchCar" })),
      meta: {
        title: "外发派车",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/LoadingOperationSheet",
      name: "LoadingOperationSheet",
      component: (resolve) =>
        require(["@/pages/DispatchCar/LoadingOperationSheet/index.vue"], (comp) =>
          resolve({ ...comp.default, name: "LoadingOperationSheet" })),
      meta: {
        title: "装货作业单",
        keepAlive: true,
      }
    },
    {
      path: "/DispatchCar/EditLoadingOperationSheet",
      name: "EditLoadingOperationSheet",
      component: (resolve) =>
        require(["@/pages/DispatchCar/LoadingOperationSheet/editSheet.vue"], (comp) =>
          resolve({ ...comp.default, name: "EditLoadingOperationSheet" })),
      meta: {
        title: "修改装货作业单",
        keepAlive: true,
      },
      props ({query:{dispatchId,loadOrderId,prev} }) {
        return { dispatchId,loadOrderId,prev};
      },
    },
    {
      path: "/DispatchCar/LoadingOperationSheetDetails",
      name: "LoadingOperationSheetDetails",
      component: (resolve) =>
        require(["@/pages/DispatchCar/LoadingOperationSheet/sheetDetails.vue"], (comp) =>
          resolve({ ...comp.default, name: "LoadingOperationSheetDetails" })),
      meta: {
        title: "装货作业单详情",
        keepAlive: true,
      },
      props ({query:{dispatchId,loadOrderId} }) {
        return { dispatchId,loadOrderId};
      },
    },
    {
      path: "/DispatchCar/ShippingExpenseEntry",
      name: "ShippingExpenseEntry",
      component: (resolve) =>
        require(["@/pages/DispatchCar/LoadingOperationSheet/shippingExpenseEntry.vue"], (comp) =>
          resolve({ ...comp.default, name: "ShippingExpenseEntry" })),
      meta: {
        title: "装货费用录入",
        keepAlive: true,
      },
      props ({query:{dispatchId,loadOrderId} }) {
        return { dispatchId,loadOrderId};
      },
    },
    {
      path: "/DispatchCar/UnloadingOperationSheet",
      name: "UnloadingOperationSheet",
      component: (resolve) =>
        require(["@/pages/DispatchCar/UnloadingOperationSheet/index.vue"], (comp) =>
          resolve({ ...comp.default, name: "UnloadingOperationSheet" })),
      meta: {
        title: "卸货作业单",
        keepAlive: true,
      }
    },
    {
      path: "/DispatchCar/EditUnloadingOperationSheet",
      name: "EditUnloadingOperationSheet",
      component: (resolve) =>
        require(["@/pages/DispatchCar/UnloadingOperationSheet/editUnloadingSheet.vue"], (comp) =>
          resolve({ ...comp.default, name: "EditUnloadingOperationSheet" })),
      meta: {
        title: "修改卸货作业单",
        keepAlive: true,
      },
      props ({query:{dispatchId,loadOrderId,prev} }) {
        return { dispatchId,loadOrderId,prev};
      },
    },
    {
      path: "/DispatchCar/EditUnloadingOperationSheet/intoStoreage",
      name: "EditUnloadingOperationSheetIntoStoreage",
      component: (resolve) =>
        require(["@/pages/DispatchCar/UnloadingOperationSheet/editUnloadingSheet.vue"], (comp) =>
          resolve({ ...comp.default, name: "EditUnloadingOperationSheetIntoStoreage" })),
      meta: {
        title: "卸货入库",
        keepAlive: true,
      },
      props ({query:{dispatchId,loadOrderId} }) {
        return { dispatchId,loadOrderId,op:'intoStoreage'};
      },
    },
    {
      path: "/DispatchCar/UnloadingShippingExpenseEntry",
      name: "UnloadingShippingExpenseEntry",
      component: (resolve) =>
        require(["@/pages/DispatchCar/UnloadingOperationSheet/unloadingShippingExpenseEntry.vue"], (comp) =>
          resolve({ ...comp.default, name: "UnloadingShippingExpenseEntry" })),
      meta: {
        title: "卸货费用录入",
        keepAlive: true,
      },
      props ({query:{dispatchId,loadOrderId} }) {
        return { dispatchId,loadOrderId};
      },
    },
    {
      path: "/DispatchCar/UnloadingOperationSheetDetails",
      name: "UnloadingOperationSheetDetails",
      component: (resolve) =>
        require(["@/pages/DispatchCar/UnloadingOperationSheet/unloadingSheetDetails.vue"], (comp) =>
          resolve({ ...comp.default, name: "UnloadingOperationSheetDetails" })),
      meta: {
        title: "卸货作业单详情",
        keepAlive: true,
      },
      props ({query:{dispatchId,loadOrderId} }) {
        return { dispatchId,loadOrderId};
      },
    },
    {
      path: "/DispatchCar/financeIn",
      name: "DispatchCarFinanceIn",
      component: (resolve) =>
        require(["@/pages/DispatchCar/Finance/List.vue"], (comp) =>
          resolve({ ...comp.default, name: "DispatchCarFinanceIn" })),
      meta: {
        title: "发车应付过账",
        keepAlive: true,
      },
      props ({query:{dispatchId,loadOrderId} }) {
        return { dispatchId,loadOrderId};
      },
    },
    // {
    //   path: "/DispatchCar/MainlineDispatch",
    //   name:'aaa',component: (resolve) =>
    //     require([
    //       "@/pages/DispatchCar/MainlineDispatch/MainlineDispatch",
    //     ],comp => resolve({...comp.default,name:'aaa'})),
    //   meta: {
    //     title: "干线调度",
    //     keepAlive: true,
    //   },
    // },
    // {
    //   path: "/DispatchCar/VehicleTrajectoryQuery",
    //   name:'aaa',component: (resolve) =>
    //     require([
    //       "@/pages/DispatchCar/VehicleTrajectoryQuery/VehicleTrajectoryQuery",
    //     ],comp => resolve({...comp.default,name:'aaa'})),
    //   meta: {
    //     title: "车辆轨迹查询",
    //     keepAlive: true,
    //   },
    // },
    {
      path: "/DispatchCar/VehicleStowage/ExpenseEntry",
      name: "ExpenseEntry",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/ExpenseEntry"], (comp) =>
          resolve({ ...comp.default, name: "ExpenseEntry" })),
      meta: {
        title: "费用录入",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/VehicleStowage/ExpenseSupplementaryRecording",
      name: "ExpenseSupplementaryRecording",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/VehicleStowage/ExpenseSupplementaryRecording",
        ], (comp) =>
          resolve({ ...comp.default, name: "ExpenseSupplementaryRecording" })),
      meta: {
        title: "费用补录",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/LoadedTasks",
      name: "LoadedTasks",
      component: (resolve) =>
        require(["@/pages/DispatchCar/LoadedTasks/LoadedTasks"], (comp) =>
          resolve({ ...comp.default, name: "LoadedTasks" })),
      meta: {
        title: "已配载任务",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/WaybillSorted",
      name: "WaybillSorted",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/Sorting/WaybillSorted"], (comp) =>
          resolve({ ...comp.default, name: "WaybillSorted" })),
      meta: {
        title: "待分拣运单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/PackagingSorting",
      name: "PackagingSorting",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/Sorting/PackagingSorting"], (
          comp
        ) => resolve({ ...comp.default, name: "PackagingSorting" })),
      meta: {
        title: "包装分拣",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/sortingAddEdit",
      name: "sortingAddEdit",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/Sorting/sortingAddEdit"], (
          comp
        ) => resolve({ ...comp.default, name: "sortingAddEdit" })),
      meta: {
        title: "分拣",
        keepAlive: true,
      },
    },
    {
      path: "/FinancialManagement/ExpenseReimbursement",
      name: "ExpenseReimbursement",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ExpenseReimbursement/ExpenseReimbursement",
        ], (comp) =>
          resolve({ ...comp.default, name: "ExpenseReimbursement" })),
      meta: {
        title: "费用报销",
        keepAlive: true,
      },
    },
    {
      path: "/FinancialManagement/ExpenseReimbursement/NewModificationDetails",
      name: "NewModificationDetails",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ExpenseReimbursement/NewModificationDetails",
        ], (comp) =>
          resolve({ ...comp.default, name: "NewModificationDetails" })),
      meta: {
        title: "费用报销单",
        keepAlive: true,
      },
    },
    {
      path:
        "/FinancialManagement/FinancialWriteOff/CustomerVerificationSummary",
      name: "CustomerVerificationSummary",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/CustomerVerificationSummary",
        ], (comp) =>
          resolve({ ...comp.default, name: "CustomerVerificationSummary" })),
      meta: {
        title: "客户核销总表",
        keepAlive: true,
      },
    },
    {
      path: "/FinancialManagement/FinancialWriteOff/CarrierVerificationSummary",
      name: "CarrierVerificationSummary",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/CarrierVerificationSummary",
        ], (comp) =>
          resolve({ ...comp.default, name: "CarrierVerificationSummary" })),
      meta: {
        title: "承运商核销总表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/DebitNote",
      name: "DebitNote",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FAMS/DebitNote"], (comp) =>
          resolve({ ...comp.default, name: "aDebitNoteaa" })),
      meta: {
        title: "借支单",
        keepAlive: true,
      },
    },
    {
      path: "/FM/InvoicesControlRX",
      name: "InvoicesControlRX",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/InvoicesControlRX"], (comp) =>
          resolve({ ...comp.default, name: "InvoicesControlRX" })),
      meta: {
        title: "发票管理",
        keepAlive: true,
      },
    },
    {
      path: "/FM/InvoicesControlRX/InvoicesAddRX",
      name: "InvoicesAddRX",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/InvoicesControlMOD/InvoicesAddRX",
        ], (comp) => resolve({ ...comp.default, name: "InvoicesAddRX" })),
      meta: {
        title: "开票",
        keepAlive: true,
      },
    },
    // 报表
    {
      path: "/FM/ReportManager",
      name: "ReportManager",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/ReportManager/ReportManager"], (
          comp
        ) => resolve({ ...comp.default, name: "ReportManager" })),
      meta: {
        title: "报表管理",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/AccountsReceivableDetails",
      name: "AccountsReceivableDetails",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/AccountsReceivableDetails",
        ], (comp) =>
          resolve({ ...comp.default, name: "AccountsReceivableDetails" })),
      meta: {
        title: "应收账款明细",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/CustomerAccountsReceivableStatusTable",
      name: "CustomerAccountsReceivableStatusTable",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/CustomerAccountsReceivableStatusTable",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "CustomerAccountsReceivableStatusTable",
          })),
      meta: {
        title: "客户应收账款情况表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/CarrierAccountsPayableStatusTable",
      name: "CarrierAccountsPayableStatusTable",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/CarrierAccountsPayableStatusTable",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "CarrierAccountsPayableStatusTable",
          })),
      meta: {
        title: "承运商应付账款情况表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/ReimbursementPayableStatistics",
      name: "ReimbursementPayableStatistics",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/ReimbursementPayableStatistics",
        ], (comp) =>
          resolve({ ...comp.default, name: "ReimbursementPayableStatistics" })),
      meta: {
        title: "报销应付统计",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/WaybillIncomeStatement",
      name: "WaybillIncomeStatement",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/WaybillIncomeStatement",
        ], (comp) =>
          resolve({ ...comp.default, name: "WaybillIncomeStatement" })),
      meta: {
        title: "运单损益表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/MonthlyAccountsReceivableSummary",
      name: "MonthlyAccountsReceivableSummary",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/MonthlyAccountsReceivableSummary",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "MonthlyAccountsReceivableSummary",
          })),
      meta: {
        title: "月应收汇总",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/CustomerShipmentDataDashboard",
      name: "CustomerShipmentDataDashboard",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/CustomerShipmentDataDashboard",
        ], (comp) =>
          resolve({ ...comp.default, name: "CustomerShipmentDataDashboard" })),
      meta: {
        title: "客户发货数据看板",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/CustomerServiceStatistics",
      name: "CustomerServiceStatistics",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/CustomerServiceStatistics",
        ], (comp) =>
          resolve({ ...comp.default, name: "CustomerServiceStatisticsaaa" })),
      meta: {
        title: "客服统计",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/OperationalDataStatisticsReportOperations",
      name: "OperationalDataStatisticsReportOperations",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/OperationalDataStatisticsReportOperations",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "OperationalDataStatisticsReportOperations",
          })),
      meta: {
        title: "操作数据统计报表（运营）",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/WaybillCostDetails",
      name: "WaybillCostDetails",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/WaybillCostDetails",
        ], (comp) => resolve({ ...comp.default, name: "WaybillCostDetails" })),
      meta: {
        title: "运单成本明细表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/ListOfOperatingPersonnel",
      name: "ListOfOperatingPersonnel",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/ListOfOperatingPersonnel",
        ], (comp) =>
          resolve({ ...comp.default, name: "ListOfOperatingPersonnel" })),
      meta: {
        title: "运营操作人员明细表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/SystemOperationStatistics",
      name: "SystemOperationStatistics",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/SystemOperationStatistics",
        ], (comp) =>
          resolve({ ...comp.default, name: "SystemOperationStatistics" })),
      meta: {
        title: "系统操作统计",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/NVOCCCarrierQuotation",
      name: "NVOCCCarrierQuotation",
      component: (resolve) =>
        require(["@/pages/Customers/NVOCCCarrierQuotation"], (comp) =>
          resolve({ ...comp.default, name: "NVOCCCarrierQuotation" })),
      meta: {
        title: "承运商报价",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/NVOCCLineQuotation",
      name: "NVOCCLineQuotation",
      component: (resolve) =>
        require(["@/pages/Customers/NVOCCLineQuotation"], (comp) =>
          resolve({ ...comp.default, name: "NVOCCLineQuotation" })),
      meta: {
        title: "承运商报价方案明细",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/CustomCarrierQuotation",
      name: "CustomCarrierQuotation",
      component: (resolve) =>
        require(["@/pages/Customers/CustomCarrierQuotation"], (comp) =>
          resolve({ ...comp.default, name: "CustomCarrierQuotation" })),
      meta: {
        title: "客户报价",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/CustomCarrierQuotationLC",
      name: "CustomCarrierQuotationLC",
      component: (resolve) =>
        require(["@/pages/Customers/CustomCarrierQuotationLC"], (comp) =>
          resolve({ ...comp.default, name: "CustomCarrierQuotationLC" })),
      meta: {
        title: "客户报价",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/CustomLineQuotation",
      name: "CustomLineQuotation",
      component: (resolve) =>
        require(["@/pages/Customers/CustomLineQuotation"], (comp) =>
          resolve({ ...comp.default, name: "CustomLineQuotation" })),
      meta: {
        title: "客户报价方案明细",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/VehicleInsurance",
      name: "VehicleInsurance",
      component: (resolve) =>
        require(["@/pages/VMS/VehicleInsurance"], (comp) =>
          resolve({ ...comp.default, name: "VehicleInsurance" })),
      meta: {
        title: "车辆保险",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AddressBook",
      name: "AddressBook",
      component: (resolve) =>
        require(["@/pages/SystemSetting/AddressBook"], (comp) =>
          resolve({ ...comp.default, name: "AddressBook" })),
      meta: {
        title: "地址薄",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/InvoiceHeader",
      name: "InvoiceHeader",
      component: (resolve) =>
        require(["@/pages/SystemSetting/InvoiceHeader"], (comp) =>
          resolve({ ...comp.default, name: "InvoiceHeader" })),
      meta: {
        title: "发票抬头",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/Qualifications",
      name: "Qualifications",
      component: (resolve) =>
        require(["@/pages/SystemSetting/Qualifications"], (comp) =>
          resolve({ ...comp.default, name: "Qualifications" })),
      meta: {
        title: "企业资质",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/BasicDataConfiguration",
      name: "BasicDataConfiguration",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicDataConfiguration"], (comp) =>
          resolve({ ...comp.default, name: "BasicDataConfiguration" })),
      meta: {
        title: "基础数据配置",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AbnormalCause",
      name: "AbnormalCause",
      component: (resolve) =>
        require(["@/pages/SystemSetting/AbnormalCause"], (comp) =>
          resolve({ ...comp.default, name: "AbnormalCause" })),
      meta: {
        title: "异常原因",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/TransportLine",
      name: "TransportLine",
      component: (resolve) =>
        require(["@/pages/SystemSetting/TransportLine/TransportRoute"], (comp) =>
          resolve({ ...comp.default, name: "TransportLine" })),
      meta: {
        title: "运输路线",
        keepAlive: true,
      },
    },

  ],
};
